import React from 'react'
import Navbar from '../components/navbar'
import { Link } from 'react-router-dom'
import bg1 from '../assets/images/bg.jpg'
import ShapeTwo from '../components/shape-two'
import { teamOne } from '../data'
import TeamTwo from '../components/team-two'
import Shape from '../components/shape'
import Footer from '../components/footer'

export default function PageTeam() {
  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">Team</h4>
                          <p className="text-muted mb-0">Our creative minds and team members</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li>
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Team</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>

    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title">
                      <h4 className="title mb-4">Layouts #1</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {teamOne.map((item,index)=>{
              return(
                  <div className="col-lg-3 col-md-6 col-12 mt-4 pt-2" key={index}>
                      <div className="mt-4 pt-2">
                          <div className="team position-relative d-block text-center">
                              <div className="image position-relative d-block overflow-hidden">
                                  <img src={item.image} className="img-fluid rounded" alt=""/>
                                  <div className="overlay rounded"></div>
                              </div>
                              <div className="content py-2 member-position bg-white border-bottom overflow-hidden rounded d-inline-block">
                                  <h4 className="title mb-0">{item.name}</h4>
                                  <small className="text-muted">{item.position}</small>
                              </div>
                              <ul className="list-unstyled team-social social-icon mb-0">
                                {item.social.map((el,index)=>{
                                  return(
                                    <li className="list-inline-item m-x-2" key={index}><Link to="#" className="rounded"><i className={el}></i></Link></li>
                                  )
                                })}
                              </ul>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Layout #2</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {teamOne.slice(0,4).map((item,index)=>{
              return(
                  <div className="col-md-6 col-12 mt-4 pt-2" key={index}>
                      <div className="team-list position-relative overflow-hidden shadow rounded">
                          <img src={item.image} className="img-fluid float-start" alt=""/>
                          <div className="content float-end p-4">
                              <h5 className="title mb-0">{item.name}</h5>
                              <small className="text-muted">{item.position}</small>
                              <p className="text-muted mt-3">I must explain to you how all this mistaken idea of denouncing pleasure and system.</p>
                              <ul className="list-unstyled follow social-icon social mb-0">
                                {item.social.map((el,index)=>{
                                  return(
                                      <li className="list-inline-item m-x-2" key={index}><Link to="#" className="rounded"><i className={el}></i></Link></li>
                                  )
                                })}
                              </ul>
                          </div>
                      </div>                        
                  </div>
              )
            })}
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Layout #3</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <TeamTwo/>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row justify-content-center">
              <div className="col-lg-7 col-md-8">
                  <div className="section-title text-center">
                      <h4 className="title mb-4">Creative thinkers, developer and designers apply here</h4>
                      <p className="text-muted para-desc mx-auto">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <Link to="/contact" className="btn rounded-pill btn-lg btn-outline-primary mt-4">Apply Here <i className="mdi mdi-clipboard-text-outline"></i></Link>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
